"use client";

import React, { ErrorInfo } from "react";

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  async componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);

    // // You can also log the error to an error reporting service
    // // logErrorToMyService(error, errorInfo);
    // Sentry.captureException(error);
    // await Sentry.flush();
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <p>There was an error displaying the image.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

interface Props {
  file: File;
}

const DisplayImageFile: React.FC<Props> = ({ file }) => {
  return (
    <ErrorBoundary>
      <DisplayImageFileInner file={file} />
    </ErrorBoundary>
  );
};

const DisplayImageFileInner: React.FC<Props> = ({ file }) => {
  return (
    <div className="w-full max-w-lg min-xl:max-w-3xl">
      <img
        src={URL.createObjectURL(file)}
        alt="Image file"
        className="sticky top-20 w-full rounded-md shadow-2xl"
      />
    </div>
  );
};

export default DisplayImageFile;
